import React, { useEffect, useMemo, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { Stack, Typography } from '@mui/material';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { accountStatusOptions } from '../../../enums/enums';
import CusInput from '../../../components/material-ui/CusInput';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../api/users';
import useToast from '../../../hooks/useToast';
import { useDispatch } from 'react-redux';
import { updateUserResult } from '../../../store/apps/usersSlice';
import TypographyText from '../../../components/material-ui/table/TypographyText';

export default function ChangeStatus({ open, closeModal, user = {}, setSelectUserFull }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { successToast } = useToast();
  const userId = user.userId;

  const labelByStatus = {
    locked: 'Locked',
    moderated: 'For Moderation',
    active: 'Active'
  };

  const accountStatusOptionsForSet = useMemo(() => {
    const accountStatusOptionsForSet = [...accountStatusOptions];
    delete accountStatusOptionsForSet[0];
    return accountStatusOptionsForSet.filter((el) => el);
  }, []);

  const [status, setStatus] = useState(accountStatusOptionsForSet[0].value);
  const [statusComment, setStatusComment] = useState('');

  const title = `${t('Change status user')} ${user?.login}`;

  const onSaveClick = () => {
    API_USERS.info
      .update({ userId: userId, status, statusComment })
      .then((e) => {
        successToast('Status successfully changed');
        dispatch(updateUserResult({ id: userId, dataIndx: 3, value: status }));
        setSelectUserFull((prev) => ({ ...prev, status }));
        closeModal();
      })
      .catch(console.error);
  };

  useEffect(() => {
    setStatusComment(user.statusComment);
  }, [userId]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="xs"
      onSaveClick={onSaveClick}>
      <ShowContainer condition={open} plug={<div style={{ height: '130px' }}></div>}>
        <Stack direction={'column'} gap={2}>
          <TypographyText color="textSecondary">
            {t('Current status')}:{' '}
            <TypographyText fontSize={14} color="textPrimary">
              {t(labelByStatus[user.status]) || t('not specified')}
            </TypographyText>
          </TypographyText>

          <CusLabelSelect
            label={'New status'}
            value={status}
            onChange={setStatus}
            options={accountStatusOptionsForSet}
          />
          <CusInput
            label={'Status comment'}
            rows={3}
            value={statusComment}
            onChange={(e) => setStatusComment(e.target.value)}
          />
        </Stack>
      </ShowContainer>
    </InfoDialog>
  );
}
